import { AddressVerificationStatuses } from './AddressVerificationDefinitions';

const getAddressVerificationStatus = (
  selectedAddressMatchesAddressFields: boolean,
  doesNotHaveSuggestedAddress: boolean,
) => {
  if (selectedAddressMatchesAddressFields) {
    return AddressVerificationStatuses.VERIFIED;
  }
  if (doesNotHaveSuggestedAddress) {
    return AddressVerificationStatuses.NO_RESULTS;
  }
  return AddressVerificationStatuses.NOT_VERIFIED;
};

export default getAddressVerificationStatus;
